"use strict";
exports.__esModule = true;
exports.canUseDOM = void 0;
var canUseDOM = function () { var _a; return !!(typeof window !== 'undefined' && ((_a = window === null || window === void 0 ? void 0 : window.document) === null || _a === void 0 ? void 0 : _a.createElement)); };
exports.canUseDOM = canUseDOM;
//# sourceMappingURL=canUseDOM.js.map